import { render, staticRenderFns } from "./TkBadges.vue?vue&type=template&id=a17bea82&scoped=true&"
import script from "./TkBadges.vue?vue&type=script&lang=js&"
export * from "./TkBadges.vue?vue&type=script&lang=js&"
import style0 from "./TkBadges.vue?vue&type=style&index=0&id=a17bea82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17bea82",
  null
  
)

export default component.exports